import script from "./TaskDetailTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailTab.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetailTab.vue?vue&type=style&index=0&id=981248ee&scoped=true&lang=css"
import "./TaskDetailTab.vue?vue&type=style&index=1&id=981248ee&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981248ee"]])

export default __exports__